// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import Tabs from 'presentations/views/components/atoms/Tabs';
import {
  gray04,
  primary,
  white,
  whiteFix,
} from 'presentations/views/styles/color';
import {
  borderRadius,
  fontSize,
  spacing,
  zIndex,
} from 'presentations/views/styles';
import UserListFilterNavigation, {
  UserListFilter,
} from 'presentations/views/components/organisms/UserListFilterNavigation';
import { useDashboardHomeNavigation } from './hooks';
import { ViewerItem } from 'presentations/api/schema/user';

interface Props {
  activeIndex: number | null;
  onChangeFilter?: (filters: UserListFilter) => void;
  userId: string | null;
  viewer: ViewerItem;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const { state, actions } = useDashboardHomeNavigation({
    viewer: props.viewer,
    userId: props.userId,
  });

  const tabs: any = [
    {
      label: t('Home'),
    },
  ];
  tabs.push({
    label: (
      <Todo>
        {t('Schedules')}
        {state.schedulesCount > 0 && (
          <TodoCount>{state.schedulesCount}</TodoCount>
        )}
      </Todo>
    ),
  });
  tabs.push({
    label: <Todo>{t('Form')}</Todo>,
  });
  // if (props.userId !== 'all') {
  //   tabs.push({
  //     label: t('Stats'),
  //   });
  // }

  return (
    <>
      <UserListFilterNavigation
        teamUsers={state.teamUsers} // localStorageからのmigration用にしばらくは必要
        userId={props.userId}
        onChangeFilter={props.onChangeFilter}
        viewer={props.viewer}
      />
      <NavigationContainer>
        <Tabs
          indicatorColor="primary"
          value={props.activeIndex}
          onChange={actions.onChangeTab}
          tabs={tabs}
        />
      </NavigationContainer>
    </>
  );
}

const NavigationContainer = styled.div`
  padding: 0 ${spacing(24)};
  background-color: ${white};
  position: sticky;
  top: 81px;
  z-index: ${zIndex(1100)};
  border-bottom: 1px solid ${gray04};
`;

const Todo = styled.div`
  display: inline-flex;
  align-items: center;
`;
const TodoCount = styled.span`
  margin-left: ${spacing(8)};
  padding: ${spacing(2)} ${spacing(8)};
  background-color: ${primary};
  border-radius: ${borderRadius(16)};
  color: ${whiteFix};
  font-size: ${fontSize(11)};
`;

const New = styled.span`
  margin-left: ${spacing(4)};
  color: ${primary};
  font-size: ${fontSize(11)};
`;
